import React from "react";
import { Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InputForm from "../../../../../components/inputs/InputForm";
import { faArrowUpFromBracket } from "@fortawesome/free-solid-svg-icons";
import InputNumber from "../../../../../components/inputs/InputNumber";
import InputSearch from "../../../../../components/inputs/InputSelectSearch";
import { TypeDocument } from "../../../../../enums/TypeDocument.enum";

const InfoDocumentScreen = ({
  values,
  errors,
  touched,
  onChange,
  handleBlur,
  epocas,
  validateAgreement,
}: {
  values: any;
  errors: any;
  touched: any;
  onChange: any;
  handleBlur: any;
  epocas: Array<any>;
  validateAgreement: any;
}) => {
  return (
    <div>
      {values.tag !== TypeDocument.TESIS ? (
        <>
          <Row className="d-flex justify-content-around mb-3">
            <Col xs={12} md={19} className="d-flex justify-content-center">
              <div className="d-flex flex-row">
                <div className="">
                  <InputNumber
                    label="Expendiente"
                    name="number"
                    value={values.number}
                    touched={touched.number}
                    error={errors.number}
                    onChangeMethod={onChange}
                    onBlurMethod={handleBlur}
                    required
                    disableSep
                  />
                </div>
                <p className="mt-4 fs-3 mx-1">/</p>
                <div className=" mt-2">
                  <InputNumber
                    label=""
                    name="year"
                    value={values.year}
                    touched={touched.year}
                    error={errors.year}
                    onChangeMethod={onChange}
                    onBlurMethod={handleBlur}
                    disableSep
                    maxLength={4}
                  />
                </div>
              </div>
            </Col>
          </Row>
          {validateAgreement(false) && (
            <>
              <Row className="d-flex justify-content-around">
                <Col xs={12} md={5}>
                  <InputForm
                    label="Fecha de registro"
                    name="dateRegistration"
                    type="date"
                    value={values.dateRegistration}
                    touched={touched.dateRegistration}
                    error={errors.dateRegistration}
                    onChangeMethod={onChange}
                    onBlurMethod={handleBlur}
                    required
                  />
                </Col>

                <Col xs={12} md={5}>
                  <InputForm
                    label="Fecha de ejecución"
                    name="dateExecution"
                    type="date"
                    value={values.dateExecution}
                    touched={touched.dateExecution}
                    error={errors.dateExecution}
                    onChangeMethod={onChange}
                    onBlurMethod={handleBlur}
                    required
                  />
                </Col>
              </Row>
            </>
          )}
        </>
      ) : (
        <>
          <Row className="d-flex justify-content-around mb-3">
            <Col xs={12} md={5}>
              <InputForm
                label="Fecha de publicación"
                name="datePublication"
                type="date"
                value={values.datePublication}
                touched={touched.datePublication}
                error={errors.datePublication}
                onChangeMethod={onChange}
                onBlurMethod={handleBlur}
                required
              />
            </Col>
            <Col xs={12} md={5} className="d-flex justify-content-center">
              <div className=" mt-2">
                <InputNumber
                  label="Año"
                  name="year"
                  value={values.year}
                  touched={touched.year}
                  error={errors.year}
                  onChangeMethod={onChange}
                  onBlurMethod={handleBlur}
                  disableSep
                  maxLength={4}
                  required
                />
              </div>
            </Col>
          </Row>
          <Row className="d-flex justify-content-around mb-3">
            <Col xs={12} md={5}>
              <InputSearch
                label="Epoca"
                name="epoch"
                value={values.epoch as string}
                touched={touched.epoch}
                error={errors.epoch}
                values={epocas}
                labelVal="name"
                valueVal="name"
                onChangeMethod={onChange}
                onBlurMethod={handleBlur}
              />
            </Col>
          </Row>
        </>
      )}

      <Row>
        <Col className="d-flex justify-content-center mt-5">
          <Button type="submit" className="bg-success">
            <FontAwesomeIcon
              icon={faArrowUpFromBracket}
              size="sm"
              className="me-2"
            />
            Subir Registro
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default InfoDocumentScreen;
